document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('globalModal');
    const modalTitle = modal.querySelector('.modal-title');
    const modalBody = modal.querySelector('.modal-body');
    
    const calendar = document.getElementById('modal-content-calendar');
    const originalCalendarLocation = document.getElementById('modal-content-layouts');

    document.querySelectorAll('.modal-trigger').forEach(trigger => {
        trigger.addEventListener('click', function () {
            const title = this.getAttribute('data-title') || 'Default Title';
            const contentKey = this.getAttribute('data-content-key');
            const content = document.getElementById(`modal-content-${contentKey}`);

            // Update modal title
            modalTitle.textContent = title;

            // When opening Event Calendar
            if (title === 'Event Calendar') {
                if (calendar) {
                    modalBody.innerHTML = ''; // Clear modal body
                    modalBody.appendChild(calendar); // Move calendar into the modal
                    calendar.classList.remove('hide-calendar');
                } else {
                    modalBody.innerHTML = '<p class="text-danger">Calendar not found.</p>';
                }
                return;
            }

            // For other content
            if (content) {
                const clone = content.cloneNode(true); // Clone the content
                clone.style.display = 'block'; // Ensure it's visible
                modalBody.innerHTML = ''; // Clear modal body
                modalBody.appendChild(clone); // Append it to the modal
            } else {
                modalBody.textContent = 'Content not found.';
            }
        });
    });

    // When modal is closed, move the calendar back to its original location
    modal.addEventListener('hidden.bs.modal', function () {
        if (calendar && originalCalendarLocation) {
            // Move calendar back to its original location (after #modal-content-layouts)
            calendar.classList.add('hide-calendar');
            originalCalendarLocation.parentNode.insertBefore(calendar, originalCalendarLocation.nextSibling);
        }
    });
});
